import { create, all } from 'mathjs';
import NumberSupport from 'sharedreact/utils/NumberSupport';
import { delocalizeDecimalSeparator } from 'sharedreact/utils/LanguageSupport';

const math = create(all);

math.createUnit('dE');
math.createUnit('ppmm');
math.createUnit('ppcm', '0.1 ppmm');
math.createUnit('ppi', '0.03937007874016 ppmm'); // 1/25.4 ppmm
math.createUnit('gupi', '0.0001 mm');

math.createUnit('lpmm');
math.createUnit('lpcm', '0.1 lpmm');
math.createUnit('lpi', '0.03937007874016 lpmm'); // 1/25.4 lpmm

math.createUnit('point', `${25.4 / 72.0} mm`);

function _displayUnitToString (displayUnit: string): string {
  if (displayUnit === 'deg') {
    return '\u00B0';
  } else if (displayUnit === 'point') {
    return 'pt';
  }
  return displayUnit;
}

function _normalizeDisplayUnitInString (value: string): string {
  return value.replace('\u00B0', 'deg').replace('pt', 'point');
}

function numberToUnitString (value: number, inputUnit: string, displayUnit: string, precision: number, addUnit: boolean = true): string {
  try {
    return NumberSupport.numberToString(math.unit(value, inputUnit).toNumeric(displayUnit), precision) + (addUnit ? ' ' + _displayUnitToString(displayUnit) : '');
  } catch (e) {
  }

  return '0 ' + _displayUnitToString(displayUnit);
}

function unitStringToNumber (valueString: string, displayUnit: string, inputUnit: string, precision: number = NumberSupport.defaultPrecision): number | null {
  let numberFromString: number | null = null;
  try {
    const normalizedValueString = _normalizeDisplayUnitInString(valueString);
    let valueWithUnit: any = math.evaluate(delocalizeDecimalSeparator(normalizedValueString));
    switch (math.typeOf(valueWithUnit)) {
      case 'Unit':
        break;
      case 'number':
        valueWithUnit = math.unit(valueWithUnit, displayUnit);
        break;
      default:
        return null;
    }

    numberFromString = valueWithUnit.toNumeric(inputUnit);
    if (precision >= 0 && numberFromString != null) {
      numberFromString = math.round(numberFromString, precision);
    }
  } catch (e) {
  }
  return numberFromString;
}

function isValidUnitString (valueString: string, displayUnit: string, inputUnit: string): boolean {
  try {
    const normalizedValueString = _normalizeDisplayUnitInString(valueString);
    let valueUnit: any = math.evaluate(
      delocalizeDecimalSeparator(normalizedValueString)
    );
    switch (math.typeOf(valueUnit)) {
      case 'Unit': {
        break;
      }
      case 'number': {
        valueUnit = math.unit(valueUnit, displayUnit);
        break;
      }
      default: {
        return false;
      }
    }
    return valueUnit.to(inputUnit) != null;
  } catch (e) {
    return false;
  }
}

const UnitSupport = {
  numberToUnitString: numberToUnitString,
  unitStringToNumber: unitStringToNumber,
  isValidUnitString: isValidUnitString
};

export default UnitSupport;
